<template>
  <div>
    <markdown-editor
      v-if="enableMarkdown"
      :id="getId()"
      :value="value"
      :markdown-guide-label="lang.get('miscellaneous.markdown_guide.label')"
      :disabled="disabled"
      :in-active-tab="inActiveTab"
      @input="onInput"
    />
    <resizable-textarea
      v-else
      :id="getId()"
      :value="value"
      :disabled="disabled"
      @input="onInput"
    ></resizable-textarea>
  </div>
</template>

<script>
import Field from './Field.vue';
import MarkdownEditor from './../Shared/MarkdownEditor';
import ResizableTextarea from '../Shared/ResizableTextarea.vue';

export default {
  inject: ['lang'],
  components: {
    MarkdownEditor,
    ResizableTextarea
  },
  extends: Field,
  props: {
    enableMarkdown: {
      type: Boolean,
      default: false
    }
  }
};
</script>
